import { useMemo, useRef } from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';

import { LogUtils } from '../../../store/insights/LogUtils.js';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useLogsById, useLogsColorMap } from '../../../store/insights/useLogs.ts';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { AnimationRemain } from '../../../components/animation/AnimationRemain';
import { OutlineButton } from '../../../components/buttons/OutlineButton';

import { InsightAddListBox } from './InsightAddListBox';

export function InsightAddButton(props) {
  const triggerRef = useRef();
  const overlayTriggerState = useOverlayTriggerState({});
  const { i18n } = useI18n();

  const logs = useLogsById();
  const { colorMap } = useLogsColorMap();
  const overlayTrigger = useOverlayTrigger({ type: 'listbox' }, overlayTriggerState, triggerRef);

  const filteredLogs = useMemo(() => {
    const selectedKeys = props.selectedKeys ?? {};

    return Object.values(logs.byId ?? {}).filter((log) => {
      const units = LogUtils.getUnits(log);

      if (log.type !== 'number') return false;

      return selectedKeys[log.id] == null && units === props.units;
    });
  }, [logs.byId, props.selectedKeys, props.units]);

  return (
    <>
      <OutlineButton
        {...overlayTrigger.triggerProps}
        ref={triggerRef}
        onPress={() => overlayTriggerState.toggle()}
      >
        <OutlineButton.Icon
          source={glyph.core.plusMedium}
          color={theme.color.icon_dark}
          size={theme.icon.size_default}
        />
        <OutlineButton.Text>{i18n.messageFormatter('insights.addChart')}</OutlineButton.Text>
      </OutlineButton>

      <AnimationRemain condition={overlayTriggerState.isOpen} delay={200}>
        {(animationRemainProps) => {
          return (
            <InsightAddListBox
              targetRef={triggerRef}
              overlayProps={overlayTrigger.overlayProps}
              overlayTriggerState={overlayTriggerState}
              items={filteredLogs}
              colorMap={colorMap}
              animationRemainProps={animationRemainProps}
              onSave={props.onRequestSelectKeys}
            />
          );
        }}
      </AnimationRemain>
    </>
  );
}

function S() {}
InsightAddButton.S = S;

S.Root = OutlineButton.Root;
